import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectBorderTransportMeanList, selectCountryInfoDS } from "@EUForms/selectors";

const  CountryInfoDetail=({saveData,updateData,renderForm})=>{
    const dispatch=useDispatch()
    const dataSource=useSelector(selectCountryInfoDS)
    const onChange=useCallback(({target: {value,name}},data, otherFields={})=>dispatch(updateData({key:"countryInfo",data:{[name]:value,...otherFields}})),[updateData])
    const onBlur=useCallback(({target: {value,name}},data, otherFields={})=>saveData({"countryInfo":{[name]:value || " ",...otherFields}}),[saveData])
    const modeOfTransport = useSelector(selectBorderTransportMeanList)?.[0]?.modeOfTransport;
    const onSelect=useCallback((e, {value,name,freightPercent})=>{
        const response={}
        if(name=="placeOfLoading" && modeOfTransport==4){
          response.airFreightPercent = freightPercent || 100
        }
        if(name=="placeOfLoading" && modeOfTransport!=4){
          response.airFreightPercent = 100
        }

        if(name=="originCountry"){
          response.placeOfLoading=" "
          response.airFreightPercent=" "
        }
        else if (name=="destinationCountry")
            response.placeOfUnloading=" "

            onChange({target:{value:value?.trim(),name}},{}, response)
            onBlur({target:{value:value?.trim(),name}},{}, response)      
    },[onChange,onBlur,modeOfTransport])
    
  
  return(
    <div className="grow col formContainer">
      {renderForm && renderForm({ onSelect, dataSource })}
    </div>
  )
}


export default CountryInfoDetail